import React from "react";
import { Input,  Flex } from "@chakra-ui/react";

const ColorPicker = ({ value, onChange }) => {
  return (
    <Flex align="center" gap={2}>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="HEX Color"
        maxW="120px"
      />
      <Input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        width="40px"
        height="40px"
        padding="0"
        border="none"
      />
    </Flex>
  );
};

export default ColorPicker;
